import { Component } from '@angular/core';

@Component({
  selector: 'wsb-email-campaigns-settings',
  templateUrl: './email-campaigns-settings.component.html',
  styleUrls: ['./email-campaigns-settings.component.scss'],
  standalone: false
})
export class EmailCampaignsSettingsComponent {
  activeId = 1;

  constructor() {}
}
